import { render, staticRenderFns } from "./SendContactPage.vue?vue&type=template&id=79c1c88a&scoped=true"
import script from "./SendContactPage.vue?vue&type=script&lang=js"
export * from "./SendContactPage.vue?vue&type=script&lang=js"
import style0 from "./SendContactPage.vue?vue&type=style&index=0&id=79c1c88a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c1c88a",
  null
  
)

export default component.exports